<template>
<div class="animated fadeIn">
  <ul class="treeview">
    <li v-for="(obj, index) in dataMenu" v-bind:key="index">
      <i class="fas fa-home text-third" @click="onOpenGed(obj, null)"></i> <strong><a href="javascript:void(0)" @click="onOpenGed(obj, null)">{{ obj.nome }}</a></strong><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, null, 0)"></i>
      <ul class="mb-3">
        <li v-for="(menu, subIndex) in onGetFistLevel(obj.items)" v-bind:key="subIndex">
          <i class="fas fa-folder-open text-third" @click="onOpenGed(menu, null)"></i> <a href="javascript:void(0)" @click="onOpenGed(menu, null)">{{ menu.nome }}</a><i class="fas fa-lock text-third treeview-options-25" v-if="false"></i><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, { id: menu.id, nome: menu.nome}, 1)"></i>
          <ul>
            <li v-for="(item2, subIndex2) in onGetChildrenMenu(obj.items, menu.id)" v-bind:key="subIndex2">
              <i class="fas fa-folder-open text-third" @click="onOpenGed(item2, obj.items)"></i> <a href="javascript:void(0)" @click="onOpenGed(item2, obj.items)">{{ item2.nome }}</a><i class="fas fa-lock text-third treeview-options-25" v-if="false"></i><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, { id: item2.id, nome: item2.nome}, 2)"></i>
              <ul>
                <li v-for="(item3, subIndex3) in onGetChildrenMenu(obj.items, item2.id)" v-bind:key="subIndex3">
                  <i class="fas fa-folder-open text-third" @click="onOpenGed(item3, obj.items)"></i> <a href="javascript:void(0)" @click="onOpenGed(item3, obj.items)">{{ item3.nome }}</a><i class="fas fa-lock text-third treeview-options-25" v-if="false"></i><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, { id: item3.id, nome: item3.nome}, 3)"></i>
                  <ul>
                    <li v-for="(item4, subIndex4) in onGetChildrenMenu(obj.items, item3.id)" v-bind:key="subIndex4">
                      <i class="fas fa-folder-open text-third" @click="onOpenGed(item4, obj.items)"></i> <a href="javascript:void(0)" @click="onOpenGed(item4, obj.items)">{{ item4.nome }}</a><i class="fas fa-lock text-third treeview-options-25" v-if="false"></i><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, { id: item4.id, nome: item4.nome}, 4)"></i>
                      <ul>
                        <li v-for="(item5, subIndex5) in onGetChildrenMenu(obj.items, item4.id)" v-bind:key="subIndex5">
                          <i class="fas fa-folder-open text-third" @click="onOpenGed(item5, obj.items)"></i> <a href="javascript:void(0)" @click="onOpenGed(item5, obj.items)">{{ item5.nome }}</a><i class="fas fa-lock text-third treeview-options-25" v-if="false"></i>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <hr>
    </li>
  </ul>
</div>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import TreviewItemGed from './treviewItemGed.vue'

export default {
  name: 'Treeview',
  data () {
    return {
      menu: []
    }
  },
  components: {
    TreviewItemGed
  },
  computed: {
    dataMenu () {
      return this.menu
    }
  },
  methods: {
    onLoad (menuList) {
      this.menu = menuList
    },
    onOpenGed (obj, menu) {
      let pathGed = []
      if (obj && obj.nivel >= 0) {
        pathGed.push(obj.nome)
        if (obj.nivel > 0) {
          let level = obj.nivel
          let item = obj
          while (level > 0) {
            item = this.onGetFatherMenu(menu, item.menuId)
            if (item) {
              pathGed.push(item.nome)
              level = item.nivel
            } else {
              level = 0
            }
          }
        }
      } else {
        toast.info('Selecione uma pasta abaixo da seção ' + obj.nome + ' para abrir!', 'GED')
        return false
      }
      obj.path = pathGed.reverse()
      this.$emit('OpenGed', obj)
    },
    onNewItemMenu (secao, menu, nivel) {
      this.$emit('New', secao, menu, nivel)
    },
    onGetFistLevel (menu) {
      let firstLevel = []
      if (menu) {
        firstLevel = menu.filter(item => item.nivel === 0)
      }
      return firstLevel
    },
    onGetChildrenMenu (menu, pai) {
      let children = []
      if (menu) {
        menu.forEach(element => {
          if (element.menuId === pai) {
            children.push(element)
          }
        })
      }
      return children
    },
    onGetFatherMenu (menu, pai) {
      let father = null
      if (menu) {
        father = menu.find(x => x.id === pai)
      }
      return father
    }
  }
}
</script>
<style scoped>
.treeview {
  list-style: none;
  margin: 0;
  padding: 0;
}
.treeview ul {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 10px;
  padding-top: 3px;
}
.treeview ul li {
  list-style-type: none;
  padding-left: 3px;
  padding-top: 3px;
}
.treeview-options-15 {
  position: absolute;
  right: 15px;
  z-index: 9;
}
.treeview-options-25 {
  position: absolute;
  right: 34px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/ged/leftcontent/components/Treeview/treeviewMenuGed.vue